import { Icon, Paragraph } from '@landingi/landingi-ui-kit'
import styles from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal/SummarySubscriptionModal.module.scss'
import { Trans } from 'react-i18next'

export const ChosenPlan = ({ packageName }: { packageName: string }) => (
  <div className={styles['summary-subscription-modal__row']}>
    <div className={styles['summary-subscription-modal__icon']}>
      <Icon icon='icon-check-circle-outline' size={14} />
    </div>
    <div>
      <Paragraph weight={400} line={20} size={16} padding='none'>
        <Trans i18nKey='change.plan.page.chosen.plan' />
      </Paragraph>
    </div>
    <div>
      <Paragraph weight={700} line={20} size={16} padding='none'>
        {packageName}
      </Paragraph>
    </div>
  </div>
)
